import { createSelector } from '@reduxjs/toolkit';
import { partnersWithContacts } from './partners-with-contacts';
import type { PartnerContactAsUser } from './partner-contact-as-user';
import { flatMap } from '../utilities/flatMap';
import { _sortByName } from '../utilities/_sortByName';
import { _sortByFirstAndLastName } from '../utilities/_sortByFirstAndLastName';

export const getContactsAsUsers = createSelector(partnersWithContacts, function (partners): PartnerContactAsUser[] {
  const p = partners
    .filter(function (e) {
      return !e.deleted;
    })
    .sort(_sortByName);
  return flatMap(p, function (e) {
    return e.contacts
      .filter(function (c) {
        return !c.deleted;
      })
      .sort(_sortByFirstAndLastName)
      .map(function (c) {
        return {
          partnerName: e.name,
          name: c.firstName + ' ' + c.lastName,
          accessLevel: c.accessLevel,
          uuid: c.uuid,
          email: c.email,
          partnerUuid: e.uuid,
          accessExpires: c.accessExpires,
        };
      });
  });
});
